import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialDiscussionState: Dtos.Discussion & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    committeeId: null,
    committee: null,
    outcomeId: null,
    outcome: null,
    committeeMeetingId: null,
    committeeMeeting: null,
    comment: null,
    studyChairId: null,
    studyChair: null,
    coChairId: null,
    coChair: null,
    endorseDate: null,
    submitFundingId: null,
    submitFundingDate: null,
    submitFundingToId: null,
    approvalId: null,
    approvalDate: null,
    approvalComment: null,
    fundingId: null,
    fundingDate: null,

    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IDiscussionReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    committeeId: IFieldState<number>,
    committeeMeetingId: IFieldState<number>,
    outcomeId: IFieldState<number>,
    comment: IFieldState<string>,
    studyChairId: IFieldState<number>,
    studyChair: IFieldState<Dtos.Personnel>,
    coChairId: IFieldState<number>,
    coChair: IFieldState<Dtos.Personnel>,
    endorseDate: IFieldState<string>,
    submitFundingId: IFieldState<number>,
    submitFundingDate: IFieldState<string>,
    submitFundingToId: IFieldState<number>,
    approvalId: IFieldState<number>,
    approvalDate: IFieldState<string>,
    approvalComment: IFieldState<string>,
    fundingId: IFieldState<number>,
    fundingDate: IFieldState<string>,

    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    openedModals: IFieldState<string[]>,
}
